<template>
  <div class="pta-admin">
    <div class="page-titles border-bottom">
      <h3>AI Marketing Docs</h3>
      <sort-by class="pull-right" :order-by-options="orderByOptions" :sort-by="filterUserForm.sort_by" :order="filterUserForm.order" @updateSortBy="value => {filterUserForm.sort_by = value}"  @updateOrder="value => {filterUserForm.order = value}"></sort-by>
      <button class="btn btn-info btn-sm pull-right m-r-10" v-if="!showFilterPanel" @click="showFilterPanel = !showFilterPanel"><i class="fas fa-filter"></i> <span class="d-none d-sm-inline">{{trans('general.filter')}}</span></button>
    </div>
    <div class="container-fluid p-0" style="font-size: 0.75em;">
      <div class="row">
        <div class="col-12">
          <transition name="fade">
            <div class="card border-bottom" v-if="showFilterPanel">
              <div class="card-body p-4">
                <h4 class="card-title">{{trans('general.filter')}}</h4>
                <div class="row">
                  <div class="col-6 col-sm-3">
                    <div class="form-group">
                      <label for="name">{{trans('user.name')}}</label>
                      <input class="form-control" id="name" name="name" v-model="filterUserForm.name">
                    </div>
                  </div>
                  <div class="col-6 col-sm-3">
                    <div class="form-group">
                      <label for="email">{{trans('user.email')}}</label>
                      <input class="form-control" id="email" name="email" v-model="filterUserForm.email">
                    </div>
                  </div>
                  <!-- <div class="col-6 col-sm-3">
                     <div class="form-group">
                       <label for="role_id">{{trans('role.role')}}</label>
                       <select v-model="filterUserForm.role_id" id="role_id" class="custom-select col-12">
                         <option value="">{{trans('general.select_one')}}</option>
                         <option v-for="role in roles" v-bind:value="role.id">
                           {{ role.name }}
                         </option>
                       </select>
                     </div>
                   </div> -->
                  <div class="col-6 col-sm-3">
                    <div class="form-group">
                      <label for="status">Premium</label>
                      <select v-model="filterUserForm.is_premium" id="status" class="custom-select col-12">
                        <option value="">{{trans('general.select_one')}}</option>
                        <option value="0">No</option>
                        <option value="1">Yes</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-6 col-sm-3">
                    <div class="form-group">
                      <label for="status">{{trans('user.status')}}</label>
                      <select v-model="filterUserForm.status" id="status" class="custom-select col-12">
                        <option value="">{{trans('general.select_one')}}</option>
                        <option value="activated">{{trans('user.status_activated')}}</option>
                        <option value="pending_activation">{{trans('user.status_pending_activation')}}</option>
                        <option value="pending_approval">{{trans('user.status_pending_approval')}}</option>
                        <option value="banned">{{trans('user.status_banned')}}</option>
                        <option value="disapproved">{{trans('user.status_disapproved')}}</option>
                      </select>
                    </div>
                  </div>
                  <!--  <div class="col-6 col-sm-6">
                     <div class="form-group">
                       <date-range-picker :start-date.sync="filterUserForm.created_at_start_date" :end-date.sync="filterUserForm.created_at_end_date" :label="trans('user.created_at')"></date-range-picker>
                     </div>
                   </div> -->
                </div>
                <button class="btn btn-danger btn-sm pull-right" v-if="showFilterPanel" @click="showFilterPanel = !showFilterPanel">{{trans('general.cancel')}}</button>
              </div>
            </div>
          </transition>
        </div>
      </div>
      <div class="card" v-if="users.total">
        <div class="card-body">
          <div class="table-responsive" v-if="hasPermission('list-user') && users.total">
            <table class="table table-hover">
              <thead>
              <tr>
                <th scope="col">{{trans('user.first_name')}}</th>
                <th scope="col">{{trans('user.last_name')}}</th>
                <th scope="col">{{trans('user.email')}}</th>
                <th scope="col">Premium</th>
                <th scope="col">{{trans('user.status')}}</th>
                <th scope="col" class="table-option">{{trans('general.action')}}</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="user in users.data" v-if="user.investors.length">
                <td v-text="user.profile.first_name"></td>
                <td v-text="user.profile.last_name"></td>
                <td v-text="user.email"></td>
                <td v-text="user.profile.is_premium?'Yes':'No'"></td>
                <td><span v-for="status in getUserStatus(user)" :class="['label','label-'+status.color,'m-r-5']">{{status.label}}</span></td>
                <td class="table-option">
                  <div class="btn-group">
                    <a :href="'/ps2/'+user.id+'/pdf'" target="_blank" class="btn btn-info btn-sm" v-tooltip="'Presentation'"><i class="fas fa-file-alt"></i></a>
                    <a :href="'/account/users/general-partners/'+user.id+'/fact-sheet-v2'" class="btn btn-info btn-sm" v-tooltip="'Fact Sheet'"><i class="fas fa-file-alt"></i></a>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <!--  <module-info v-if="!users.total" module="user" title="module_info_title" description="module_info_description" icon="users">
                <div slot="btn">
                    <button class="btn btn-info btn-sm" v-if="hasPermission('create-user') && !showCreatePanel" @click="showCreatePanel = !showCreatePanel"><i class="fas fa-plus"></i> {{trans('general.add_new')}}</button>
                </div>
            </module-info>
             --><pagination-record :page-length.sync="filterUserForm.page_length" :records="users" @updateRecords="getUsers"></pagination-record>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import sortBy from '../../components/sort-by'
export default {
  components : { sortBy },
  data() {
    return {
      users: {
        total: 0,
        data: []
      },
      filterUserForm: {
        name: '',
        email: '',
        role_id: '',
        status: '',
        created_at_start_date: '',
        created_at_end_date: '',
        sort_by : 'first_name',
        order: 'asc',
        page_length: 50
      },
      showFilterPanel: false,
      orderByOptions: [
        {
          value: 'first_name',
          translation: i18n.user.first_name
        },
        {
          value: 'last_name',
          translation: i18n.user.last_name
        },
        {
          value: 'email',
          translation: i18n.user.email
        },
        {
          value: 'status',
          translation: i18n.user.status
        },
        {
          value: 'created_at',
          translation: i18n.user.created_at
        }
      ],
    };
  },
  mounted(){
    if(!helper.hasPermission('list-user') && !helper.hasPermission('create-user')){
      helper.notAccessibleMsg();
      this.$router.push('/home');
    }
    this.getUsers();
  },
  methods: {
    hasPermission(permission){
      return helper.hasPermission(permission);
    },
    getUserStatus(user){
      return helper.getUserStatus(user);
    },
    getUsers(page){
      if (typeof page !== 'number') {
        page = 1;
      }
      let url = helper.getFilterURL(this.filterUserForm);
      axios.get('/api/user?page=' + page + url)
          .then(response => response.data)
          .then(response => this.users = response)
          .catch(error => {
            helper.showDataErrorMsg(error);
          })
    },
  },
  watch: {
    filterUserForm: {
      handler(val){
        this.getUsers();
      },
      deep: true
    }
  },
  filters: {
    moment(date) {
      return helper.formatDate(date);
    }
  }
}
</script>
<style>
.pta-ai-results table td{
  font-size:0.8em;
  line-height:1.25em;
  padding:8px;
  vertical-align:top;
}
.pta-ai-results table tr:nth-child(odd){
  background:#efefef;
}
</style>
